import React, { Component } from 'react';
import {
    EmvioCard as Card,
    EmvioLoadingSpinner as LoadingSpinner
} from '@nexio/emvio-util-ui';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './AgentResidualsWidget.scss';

export default class AgentResidualsWidget extends Component {
    static propTypes = {
        residualsData: PropTypes.any,
        isLoading: PropTypes.bool
    };

    render(){
        const residualsData = this.props.residualsData;
        const agentName = _.get(this.props, 'residualsData.agentName');

        return (

            <Card className="agent-residuals-summary-card" >
                {this.props.isLoading !== false
                    ? <LoadingSpinner/>
                    : <div className="widget-content">
                        <div className="agent-residuals-widget-header">{`Agent Residuals for ${agentName}`}</div>
                        <div className="columns">
                            {_.map(_.omit(residualsData, 'agentName'), (item, key) => {
                                return <div className="agent-residual-item" key={key}>
                                    <div className="agent-residual-widget-column-title">{_.upperCase(key)}</div>
                                    <div className="agent-residual-widget-column-value">{item}</div>
                                </div>;
                            })}
                        </div>
                    </div>
                }
            </Card>
        );
    }
}
